import React, { useMemo } from 'react';
import { dealwithLeftInfoData } from '../../pages/community/hashtag/utils';
import ChannelLabel from '@/pages/opinion/components/ChannelLabel';
import RegionCountryItem from '@/pages/opinion/components/Snippets/RegionCountryItem';
import { getShowCount, transLanguage } from '@/pages/opinion/utils';
import Tips from '@/pages/opinion/components/Snippets/Tips';
import { useIntl } from 'umi';
import './index.scss';
import '../ProgressInfoBox/index.scss';

export function LeftInfo({
  leftInfoData,
  loading,
  apiError,
  noShowChannel = false,
}: {
  leftInfoData: {
    language: Array<any>;
    country: Array<any>;
    channel: Array<any>;
  };
  loading: boolean;
  apiError: boolean;
  noShowChannel: boolean;
}) {
  const { formatMessage } = useIntl();
  const listArrayMemo = useMemo(() => {
    const { language, country, channel } = dealwithLeftInfoData(leftInfoData);

    let basicList = [
      {
        title: formatMessage({ id: 'Language' }),
        color: '#5893FF',
        beforeRender: (item: any) => (
          <div className="progress-infobox-itemlabel">
            <span className="progress-infobox-subtitle">
              {transLanguage(item.name)}
            </span>
          </div>
        ),
        list: language?.slice(0, 3),
      },
      {
        title: formatMessage({ id: 'Region/Country' }),
        color: '#77E097',
        beforeRender: (item: any) => (
          <div className="progress-infobox-itemlabel">
            <RegionCountryItem
              style={{ alignItems: 'baseline' }}
              market={item.name}
              isShortText
            ></RegionCountryItem>
          </div>
        ),
        list: country?.slice(0, 3),
      },
      {
        title: formatMessage({ id: 'Channel' }),
        color: '#77E097',
        beforeRender: (item: any) => {
          return (
            <div className="progress-infobox-itemlabel">
              <ChannelLabel channel_name={item.name}></ChannelLabel>
            </div>
          );
        },
        list: channel?.slice(0, 3),
      },
    ];

    if (noShowChannel) {
      basicList.splice(2, 1);
    }

    return basicList;
  }, [leftInfoData, formatMessage]);

  const ListInfoElement = (listArray: Array<any>) => {
    return listArray.map(({ color, title, beforeRender, list }) => (
      <div className="dbo-progress-infobox" key={title}>
        <div className="progress-infobox-title">{title}</div>
        <Tips
          noDataStyle={{
            height: 50,
            lineHeight: '50px',
            display: 'block',
            textAlign: 'center',
          }}
          loading={loading}
          apiError={apiError}
          noData={list?.length === 0}
        >
          {list?.map((item: any) => {
            return (
              <div className="progress-infobox-cont" key={item.name}>
                {beforeRender(item)}
                <div className={'tea-progress progress-infobox-style'}>
                  <div
                    className={'tea-progress__value'}
                    style={{ backgroundColor: color, width: item.progress }}
                  ></div>
                </div>
                <span className={'progress-infobox-num'}>
                  {getShowCount(item.value)}
                </span>
                <span className={'progress-infobox-text'}>{item.progress}</span>
              </div>
            );
          })}
        </Tips>
      </div>
    ));
  };

  return (
    <div className="table-expandable-detail-l">
      {ListInfoElement(listArrayMemo)}
    </div>
  );
}
